import { selector } from 'recoil';
import { topConfigContextAtom } from '../atoms/topConfigContextAtom';

export const isLoggedOnSelector = selector<boolean>({
    key: 'isLoggedOnSelector',
    get: ({ get }) => {
        const topConfigContext = get(topConfigContextAtom);
        return topConfigContext?.user?.isLoggedOn ?? false;
    }
});
